import { render, staticRenderFns } from "./businessGoodsTax.vue?vue&type=template&id=7a3dd8d1&scoped=true"
import script from "./businessGoodsTax.vue?vue&type=script&lang=js"
export * from "./businessGoodsTax.vue?vue&type=script&lang=js"
import style0 from "./businessGoodsTax.vue?vue&type=style&index=0&id=7a3dd8d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3dd8d1",
  null
  
)

export default component.exports